<template>
    <div class="customLabel">
        <div class="left" :style="styleObj">
            <slot></slot>
        </div>
        <div class="right">
            <slot name="right"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "customLabel",
    props: {
        fs: {
            type: String,
            default: ""
        }
    },
    computed: {
        styleObj() {
            return {
                fontSize: this.fs + "px"
            };
        }
    }
};
</script>

<style lang="scss" scoped>
.customLabel {
    display: flex;
    justify-content: space-between;
    .left {
        font-size: 16px;
        font-weight: bold;
        color: #303133;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/CustomLabel/index.vue